import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  screenName$ = new BehaviorSubject<string>('list');
  employeeName$ = new BehaviorSubject<string>('');
  isList = true;
  employeeId = '';
  contractId = '';

  setComponent(stepName: string): void {
    this.screenName$.next(stepName);
    if (stepName !== 'list') {
      this.isList = false;
    }
  }

  setEmployeeId(employeeId: string, contractId: string): void {
    this.employeeId = employeeId;
    this.contractId = contractId;
  }

  hasMiddleName(input?: string) {
    if (input && input !== '') {
      return true;
    } else return false;
  }

  async setEmployeeName(first: string, middle: string, last: string) {
    const name = this.formatFullName(first, middle, last);
    this.employeeName$.next(name);
  }

  formatFullName(first?: string, middle?: string, last?: string) {
    const hasMiddleName = this.hasMiddleName(middle);

    if (hasMiddleName) {
      return `${first} ` + `${middle?.[0]} ` + `${last}`;
    } else {
      return `${first} ${last}`;
    }
  }
}
